import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const CaptchaInput = forwardRef(({ captchaKey, onChange }, ref) => (
  <ReCAPTCHA sitekey={captchaKey} onChange={onChange} ref={ref} />
));

export default CaptchaInput;
